
import { DATA } from "../../data";
import { useWindowDimensions } from "../../hooks/useDimensions";
import React from "react";
import { useState } from "react";
import Imagehover from "./Imagehover";
import {
  motion,
  useScroll,
  useMotionValueEvent,
  useAnimation,
  useIn,
} from "framer-motion";

function Speakers() {
  const speakers = DATA.speakers;
  const dimens = useWindowDimensions();

  const [speaker, setSpeaker] = useState("");
  const [activeInd, setActiveInd] = useState(-1);

  function toggleImage(string) {
    if (speaker !== string) {
      setSpeaker(string);
    } else {
      setSpeaker("");
    }
  }

  return (
    <>
      <div
        id="schedule"
        className="font-apfelgrotezk mx-3 tablet:mx-4 desktop:mx-8 max-w-[50rem] mb-32 sm:text-xl"
      >
        {speakers.map((item, i) => (
          <div
            key={i}
            onMouseEnter={() => setActiveInd(i)}
            onMouseLeave={() => setActiveInd(-1)}
          >
            <div className="flex flex-col md:flex-row flex-wrap py-2 tablet:py-4 justify-between gap-y-1 items-baseline  ">
              {/* {const isActive = index === active;} */}
              {i === activeInd && (
                <Imagehover path={item.img} active={activeInd} />
              )}

              {item.checkpoint && (
                <h3 className="uppercase text-3xl tablet:text-5xl flex-none z-20 leading-none py-3 tablet:py-0">
                  {item.checkpoint}
                </h3>
              )}

              {item.company && (
                <div className="flex gap-x-1 tablet:gap-x-2 md:w-72 mr-16 z-20">
                  <h3
                    onClick={() => toggleImage(item.name)}
                    className="uppercase text-xl tablet:text-2xl leading-none"
                  >
                    {item.company}
                  </h3>
                  {item.location && (
                    <div className="px-1 tablet:p-1 uppercase bg-chocolate text-strawberry text-base flex-none">
                      {item.location}{" "}
                    </div>
                  )}
                </div>
              )}

              {dimens.width >= 768 && <p className="z-20">{item.name}</p>}
              <div className="ml-auto -20 text-xs tablet:text-base">
                {item.name && dimens.width < 768 ? (
                  <p>
                    {item.name} ({item.designation.toUpperCase()}) @ {item.time}
                  </p>
                ) : (
                  <p>
                    {item.designation && `${item.designation.toUpperCase()} @`}{" "}
                    {item.time}
                  </p>
                )}
              </div>
            </div>
            {item.mobimg && (
              <div
                className={`overflow-hidden max-height transition-all duration-700 ease ${
                  speaker === item.name ? "max-h-[400px]" : "max-h-0"
                }`}
              >
                <img
                  className="tablet:hidden mb-3 w-screen"
                  src={item.mobimg}
                ></img>
              </div>
            )}
            {item.footnote && (
              <p className="text-[9px] tablet:text-xs mb-2 tablet:mb-4 opacity-60 z-20 pointer-events-none">
                {item.footnote}
              </p>
            )}
            {i < speakers.length - 1 && (
              <div className="border-b border-chocolate z-40 relative opacity-50 tablet:opacity-100"></div>
            )}
          </div>
        ))}
      </div>
    </>
  );
}

export default Speakers;



